module.exports = __webpack_public_path__ + "assets/img/chef-8.3930112b.jpg";